module.exports = __webpack_public_path__ + "media/images/items/thumbnail-1-474f4de4807ef20855ca0de7c9e6aa13.jpg";